import { useEffect } from 'react';
import { getDefaultStore } from 'jotai';
import { authUserMetaAtom } from '@/store/authAtoms';

/**
 * Detects a ?remoteAccessToken query param placed by PatientAdminMUI.
 * Redirects to /remote-access-login preserving the token — the admin must authenticate
 * with their l_user credentials before a patient session is created.
 *
 * Mounted before <RouterProvider> so useNavigate() is unavailable.
 */
export function RemoteAccessBootstrap() {
  useEffect(() => {
    const params            = new URLSearchParams(window.location.search);
    const remoteAccessToken = params.get('remoteAccessToken');
    if (!remoteAccessToken) return;

    // Already on the remote access login page — let RemoteAccessLogin handle it.
    if (window.location.pathname === '/remote-access-login') return;

    // Clear any stale auth state from localStorage so that bootstrapAuth on the
    // /remote-access-login page finds null and returns early, preventing a race where an
    // in-flight SessionStatus 401 clears the auth atom after RemoteAccessLogin sets it.
    getDefaultStore().set(authUserMetaAtom, null);

    const icode = params.get('icode');
    const dest  = new URLSearchParams({ remoteAccessToken });
    if (icode) dest.set('icode', icode);

    window.location.replace(`/remote-access-login?${dest.toString()}`);
    // Run only once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
